import {Icon} from 'components/atoms/Media/Icon';
import {keyboardClickable} from 'components/hooks/keyboardClickable';
import {getFormattedMessage} from 'features/services/utils/language-helper';
import {LogoJM} from 'components/atoms/Media/Logo/_logo-jm';
import {SiteSpecificContent} from 'components/atoms/SiteSpecificContent';
import {useUiStore} from 'features/ui/store/useUiStore';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';

import './style.scss';
import {useLocation} from 'react-router';

interface Props {
    inStorybook?: boolean;
}

export const RedirectMessage: React.FunctionComponent<Props> = ({inStorybook}) => {

    const setRedirectMessageVisibility = useUiStore((state) => state.setRedirectMessageVisibility);
    const location = useLocation();

    const shouldShowMessage = () => (location.search === '?redirectedFrom=sv' || inStorybook);
    if(!shouldShowMessage()) return null;

    return (
        <div className="redirect-message" aria-label={getFormattedMessage('jm.a11y.close')} {...keyboardClickable(() => setRedirectMessageVisibility(false))}>
            <LogoJM/>
            <SiteSpecificContent showOnBoratt>
                <FormattedMessage id="jm.components.RedirectMessage.boratt" />
            </SiteSpecificContent>
            <SiteSpecificContent showOnSeniorGarden>
                <FormattedMessage id="jm.components.RedirectMessage.seniorgarden" />
            </SiteSpecificContent>
            <Icon name="x" className="redirect-message__close" size={24}  />
        </div>
    )
};
